import {type Descendant} from 'slate';

// Window dimensions
export const DEFAULT_WINDOW_WIDTH = 522;
export const DEFAULT_WINDOW_HEIGHT = 600;
export const MIN_WINDOW_WIDTH = 320;
export const MIN_WINDOW_HEIGHT = 300;
export const DEFAULT_DRAWER_WIDTH = 522;
export const MIN_DRAWER_WIDTH = 320;
export const MAX_DRAWER_WIDTH = 1569;

export const COMPOSER_INITIAL_VALUE: Descendant[] = [
  {type: 'paragraph', children: [{text: ''}]},
];
